module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "Perfect-Center"
  }, [_c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("In loving dedication to The Yo-Yos, lifelong serial friends: Ellen, Ginny, Joan, Jutta, Pennie, and Randi…plus honorary Yo-Yo, Wayne")])]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("A special thank you to Stevan Gould and Patty Gordon, plus WildBlue Press and their amazing staff: Steve Jackson, Michael Cordova, Ashley Kaesemeyer, and Rowe Carenen")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe47142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Foreword2.vue
// module id = 75
// module chunks = 0